// export { default } from 'components/commission-management/payment-certificates/form';

import SalesOrderPaymentCertificateForm from "components/commission-management/payment-certificates/form";
export default SalesOrderPaymentCertificateForm;
